package pogolitics.model

data class IVs(val attack: Int, val defense: Int, val stamina: Int)